import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["article"]
  connect() {
    // console.log("connect");
  }

  getArticle(event){
    event.preventDefault();
    const csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    console.log(event.params.url)
    fetch(event.params.url, {
      method: "POST",
      headers: { "X-CSRF-Token": csrf },
      // body: formData
    }).then(response => response.json())
    .then(data => {
      const paragraphs = this.articleTarget.querySelectorAll('p');
      paragraphs.forEach(p => {p.remove(); });
      const text = data.text
      console.log(text)
      // const spinner = this.element.querySelector('#spinner');
      // spinner.remove();

      this.articleTarget.insertAdjacentHTML("beforeend", `<p id="new-idea" class="bg-white border rounded mt-3">${text}</p>`);
    });
  }

  saveIdea() {
    const recorderBox = this.element.querySelector('#recorder-box');
    const newIdea = recorderBox.querySelector('#new-idea');
    let txt = "";

    if (newIdea === null) {
      txt = "";
    } else {
      txt = newIdea.innerText;
    }
  }
}
